import banner from "../../../courses/module-1/img2.png";

const modulo2 = {
  courseId: "finanzas-personales",
  id: "modulo-2",
  title: "📘 MODULE 2: Smart Budgeting",
  estimatedDuration: "2 hours",
  format: "Reading + practical activity + personal budget submission",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objectives",
      content: [
        "Learn what a budget is and why it is key to managing your money consciously.",
        "Differentiate between types of expenses and detect where your money is going.",
        "Design your own monthly budget using simple tools and a model table.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Main reading",
      title: "📖 Main reading: How do you make a budget?",
      content: [
        {
          type: "paragraph",
          text: "A budget is a tool that helps you plan your income and expenses. It is like a map that tells you how much you can spend and on what, so you do not run out of money before your next paycheck.",
        },
        {
          type: "paragraph",
          text: "In simple terms: budgeting means deciding before spending.",
        },
      ],
    },
    {
      id: "importancia",
      navLabel: "Why is it important?",
      title: "🧠 Why is it important?",
      content: [
        {
          type: "list",
          items: [
            "It helps you avoid unpleasant surprises like “Wait, I already ran out of money?!”",
            "It helps you reach goals, such as traveling, saving, or buying something important.",
            "It gives you control and clarity over your financial life.",
          ],
        },
      ],
    },
    {
      id: "tipos-gastos",
      navLabel: "Types of expenses",
      title: "💸 Types of expenses: focus the lens",
      content: [
        {
          type: "table",
          headers: ["Type of expense", "What is it?", "Examples"],
          rows: [
            [
              "Fixed",
              "They are always there, month after month.",
              "Rent, phone plan, transportation to university",
            ],
            [
              "Variable",
              "They change depending on the month.",
              "Eating out, outings, phone top-ups, gas",
            ],
            [
              "Discretionary",
              "They are wants or treats.",
              "Starbucks, new clothes, delivery, gadgets",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "Pro tip: It is not about eliminating what you enjoy, but about deciding intentionally how much you can spend on it without neglecting everything else.",
        },
      ],
    },
    {
      id: "ejemplo-practico",
      navLabel: "Practical example",
      title: "📊 Practical example: your budget table in action",
      content: [
        {
          type: "link",
          href: "https://docs.google.com/spreadsheets/d/1FBMOSfjV1ePG5mUFOwbdvzxE3S_1nfqXG4F_ouuKtVQ/edit?usp=sharing",
          text: "Example spreadsheet. Make a copy in your Google Drive.",
        },
        {
          type: "list",
          items: [
            "Section to enter your monthly income",
            "List of expenses organized by type: fixed, variable, previous savings",
            "Line to record your monthly savings",
            "Automatic formulas that calculate total income, expenses, and savings",
            "Final balance: what you actually have left",
          ],
        },
      ],
    },
    {
      id: "replicar-tabla",
      navLabel: "How to replicate it",
      title: "🛠 How to replicate this table",
      content: [
        {
          type: "orderedList",
          items: [
            "Create two columns: A for category and B for monthly amount.",
            "Classify your expenses according to the categories covered in this module.",
            "Use basic formulas: SUM(B2:B5) for income, SUM(B6:B15) for expenses, etc.",
            "Manually record your monthly savings or add specific rows.",
            "Add visual formatting, such as colors, bold text, and borders, to make it easier to read.",
          ],
        },
      ],
    },
    {
      id: "ejemplo-real",
      navLabel: "Real example",
      title: "💬 Real and young example: budgeting as a student",
      content: [
        {
          type: "paragraph",
          text: "Andrea is 20 years old and studies Psychology at UNAM. Her monthly income is $1,600 from a scholarship plus $800 from a part-time job. Total: $2,400 pesos. Her expenses: shared rent $1,000, transportation $300, food $500, discretionary expenses $400. Planned savings: $100. Real available balance: $300 pesos.",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Practical activity",
      title: "🧠 Practical activity to submit",
      content: [
        "Create your own monthly budget using the shared example sheet.",
        "Suggested submission: Drive link, PDF, image, or clear photo of your notebook, including income, expenses, savings, and personal goal.",
      ],
    },
    {
      id: "lecturas-recomendadas",
      navLabel: "Recommended readings",
      title: "📚 Recommended readings",
      content: [
        {
          type: "link",
          href: "https://www.condusef.gob.mx/",
          text: "Guide to making your first budget – CONDUSEF",
        },
        {
          type: "link",
          href: "https://www.pequenocerdocapitalista.com/",
          text: "Where does my money go? – Pequeño Cerdo Capitalista Blog",
        },
        {
          type: "link",
          href: "https://www.tiktok.com/@educacionfinancieramx",
          text: "TikTok @educacionfinancieramx – Visual tips for students",
        },
      ],
    },
    {
      id: "evaluacion",
      navLabel: "Quick assessment",
      title: "📝 Quick assessment",
      content: [
        {
          type: "list",
          items: [
            "Identify your real income",
            "Detect hidden or unnecessary expenses",
            "Classify your expenses correctly",
            "Use a tool to build your table",
            "Set a financial goal",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliography",
      title: "📚 Bibliography for further learning",
      content: [
        "Sofía Macías – “Pequeño Cerdo Capitalista”",
        "T. Harv Eker – “Secrets of the Millionaire Mind”",
        "CONDUSEF – Basic financial education for young people",
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: ["“Whoever controls their budget controls their freedom.”"],
    },
  ],
};

export default modulo2;
